import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
const daysOfWeek = [
  { id: 0, name: "Sunday" },
  { id: 1, name: "Monday" },
  { id: 2, name: "Tuesday" },
  { id: 3, name: "Wednesday" },
  { id: 4, name: "Thursday" },
  { id: 5, name: "Friday" },
  { id: 6, name: "Saturday" },
];
const BarberAvailabilityModal = ({
  isOpen,
  onClose,
  onSave,
  unUsedDays,
  initialData, // { day: "Monday", startTime: "09:00", endTime: "17:00" }
}) => {
  const [day, setDay] = useState();
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("00:00");

  // Load data when editing
  useEffect(() => {
    if (initialData) {
      setDay(daysOfWeek.find((d) => d.id == initialData.day) || {});
      setStartTime(initialData.startTime || "");
      setEndTime(initialData.endTime || "");
    } else {
      if (unUsedDays) {
        setDay(unUsedDays[0]);
        setStartTime("00:00");
        setEndTime("00:00");
      }
    }
  }, [initialData, isOpen]);
  const generateTimeSlots = (intervalMinutes = 15) => {
    const times = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += intervalMinutes) {
        const hour = String(h).padStart(2, "0");
        const minute = String(m).padStart(2, "0");
        times.push(`${hour}:${minute}`);
      }
    }
    return times;
  };
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!day || !startTime || !endTime) {
      alert("Please fill out all fields");
      return;
    }
    onSave({ day, startTime, endTime });
    onClose();
  };

  return (
    <div className={`modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {initialData ? "Edit" : "Add new availability"}
            </h5>
          </div>
          <div className="modal-body">
            <div className="row client-form">
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Day
                </label>
                <Combobox
                  onChange={(value) => setDay(value)}
                  data={unUsedDays}
                  dataKey="id"
                  textField="name"
                  value={day}
                  defaultValue={day}
                  containerClassName={" form-combobox"}
                />
              </div>
              <div className="col-6 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Start
                </label>
                <Combobox
                  onChange={(value) => setStartTime(value)}
                  data={generateTimeSlots()}
                  value={startTime}
                  defaultValue={startTime}
                  containerClassName={" form-combobox"}
                />
              </div>
              <div className="col-6 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  End
                </label>
                <Combobox
                  onChange={(value) => setEndTime(value)}
                  data={generateTimeSlots()}
                  value={endTime}
                  defaultValue={endTime}
                  containerClassName={" form-combobox"}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => onClose()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSubmit(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BarberAvailabilityModal;
